export default "__VITE_ASSET__46a6141e__"